import React, { ReactNode } from 'react';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import { UserOutlineIcon } from '../../icons/inputIcons';
import { IClientItem } from '../../../modules/API/Defaults/models/clients';

interface Props {
    clients: IClientItem[];
    value: IClientItem | null;
    onSelect: (client: IClientItem | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    allowClear?: boolean;
    clearLabel?: string;
    leadingIcon?: ReactNode | null;
    className?: string;
}

const ClientSelector: React.FC<Props> = ({
    clients,
    value,
    onSelect,
    placeholder = 'בחר לקוח',
    disabled,
    readOnly,
    allowClear,
    clearLabel = 'הכל',
    leadingIcon,
    className,
}) => (
    <SearchableSelect<IClientItem>
        items={clients}
        value={value}
        onSelect={onSelect}
        getKey={(c) => c.ClientID}
        getLabel={(c) => (c.ClientName ?? '').trim()}
        getSearchText={(c) => c.ClientName ?? ''}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        allowClear={allowClear}
        clearLabel={clearLabel}
        leadingIcon={leadingIcon === undefined ? <UserOutlineIcon /> : leadingIcon}
        className={className}
        emptyLabel='אין לקוחות מתאימים'
    />
);

export default ClientSelector;
